import { render, staticRenderFns } from "./DatosPersonales.vue?vue&type=template&id=f3499672&scoped=true"
import script from "./DatosPersonales.vue?vue&type=script&lang=ts"
export * from "./DatosPersonales.vue?vue&type=script&lang=ts"
import style0 from "./DatosPersonales.vue?vue&type=style&index=0&id=f3499672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3499672",
  null
  
)

export default component.exports